import type { FormEvent, JSX } from 'react'

import { AuthFormBoxInternalTemplate } from "/app/libraries/arcana/src/blocks/AuthFormBox/Templates/index.ts"
import { AuthFormBoxRowGaps } from "/app/libraries/arcana/src/blocks/AuthFormBox/index.ts"
import { PrimarySubmitButton } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"

import { useForm } from 'effector-forms'
import { useUnit } from 'effector-react'
import { $signUpFormTranslations } from '../../translations'
import { signUpForm, signUpFx } from '../model'
import { UsernameAndPasswordInputs } from './UsernameAndPasswordInputs'

export const RegistrationByEmailForm = (): JSX.Element => {
  const formTranslations = useUnit($signUpFormTranslations)

  const { submit, eachValid } = useForm(signUpForm)

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    submit()
  }
  const pending = useUnit(signUpFx.pending)

  return (
    <form onSubmit={onSubmit} autoComplete='off' noValidate>
      <AuthFormBoxInternalTemplate rowGap={AuthFormBoxRowGaps.SIZE_190}>
        <UsernameAndPasswordInputs />
        <PrimarySubmitButton
          title={formTranslations.submitButton}
          disabled={pending || !eachValid}
          withLoader
          isLoading={pending}
        />
      </AuthFormBoxInternalTemplate>
    </form>
  )
}
